import i18next from "i18next"

import Lang_en from "./en.json"
export const initI18n = () => {
  // console.warn("import i18next from 'i18next';")
  i18next.addResourceBundle("en", "setting2fa", Lang_en)
}
